// extracted by mini-css-extract-plugin
export default {"filter":"Filters__filter___naKq1"};